import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import elementType from 'prop-types-extra/lib/elementType';
import { Field } from 'redux-form';
import { noop } from 'lodash/fp';

import formValues from 'helpers/form/formValues';
import { GEOLOCATION_NAME } from 'components/searchAds/constants';
import { options as distanceOptions } from 'helpers/fieldOptions/ad/distance';
import Control from '../Control';

class DistanceField extends PureComponent {
  static propTypes = {
    onChanged: PropTypes.func,
    clearable: PropTypes.bool,
    geoLocation: PropTypes.object,
    options: PropTypes.array,
    searchable: PropTypes.bool,
    component: elementType,
  };

  static defaultProps = {
    clearable: true,
    options: distanceOptions,
    searchable: true,
    onChanged: noop,
    component: Control,
  };

  render() {
    const { options, geoLocation } = this.props;
    const location = geoLocation || {};
    const isDisabled = !options.length || !(location.lat && location.lng);

    return (
      <Field {...this.props} name={GEOLOCATION_NAME} disabled={isDisabled} />
    );
  }
}

export default formValues({ geoLocation: GEOLOCATION_NAME })(DistanceField);
